<template>
    <div>
        <div id="map" class="mb-3"></div>
        <label>Filter by country</label>
        <div class="row">
            <div class="col-md-3">
                <select class="mb-0" v-model="selected_country" @change="focus();">
                    <option :value="null">All</option>
                    <option v-for="(country, index) in branches_contacts_countries" :key="index" :value="index">{{ country }}</option>
                </select>
            </div>
            <div v-if="selected_type || selected_country" class="col-md-3 align-self-center">
                <button class="btn btn-small px-0" v-on:click="selected_type = null; selected_country = null; setMarkers(); focus()"><i class="fas fa-sync-alt"></i> Reset</button>
            </div>
        </div>
        <transition-group name="fade" class="row mt-3">
            <div v-for="branch_contact in branches_contacts_filtered" :key="branch_contact.id" class="col-md-4 col-lg-3 mb-3">
                <div v-html="branch_contact.branch_contact_card" class="p-3"></div>
            </div>
        </transition-group>
    </div>
</template>
<script>
    var markers = []
    var map = null
    var geocoder = null
    var current_location = {
        'lat': 25.358704,
        'lon': 29.471082,
        'zoom': window.innerWidth > 480 ? 2 : 1
    }
    var activeInfoWindow
    var markerCluster = null

    export default {
        props: ["dataBranchesContacts", "dataBranchesContactsCountries", "dataCountriesLatLon"],
        data() {
            return {
                branches_contacts: this.dataBranchesContacts,
                branches_contacts_countries: this.dataBranchesContactsCountries,
                countries_lat_lon: this.dataCountriesLatLon,
                selected_country: null,
                selected_type: null,
                pos_ids: []
            }
        },
        mounted() {
            geocoder = new google.maps.Geocoder();
            map = new google.maps.Map(document.getElementById('map'), {
                zoom: current_location.zoom,
                center: {lat: current_location.lat, lng: current_location.lon},
                mapTypeId: 'roadmap',
                clickableIcons: false
            });
            this.setMarkers();
            const vue = this;
            map.addListener('center_changed', function () {
                vue.filterByMarkers()
            });
            map.addListener('zoom_changed', function () {
                vue.filterByMarkers()
            });
        },
        computed: {
            branches_contacts_filtered() {
                return this.branches_contacts.filter(branch_contact => {
                    return this.selected_type ? branch_contact.type == this.selected_type : branch_contact
                }).filter(branch_contact => {
                    return this.selected_country ? branch_contact.country == this.selected_country : branch_contact
                }).filter(branch_contact => {
                    if (this.pos_ids.length) {
                        return this.pos_ids.includes(branch_contact.id)
                    } else {
                        return true
                    }
                })
            }
        },
        methods: {
            filterByMarkers() {
              this.pos_ids = []
                for (var i=0; i < markers.length; i++){
                    if( map.getBounds().contains(markers[i].getPosition()) ){
                        this.pos_ids.push(markers[i].pos_id);
                    }
                }
            },
            setMarkers() {
                this.branches_contacts_filtered.forEach((pos, index) => {
                    markers[index] = new google.maps.Marker({
                        position: {lat: Number(pos.lat), lng: Number(pos.lon)},
                        map: map,
                        icon: '/images/marker-'+pos.type+'.png',
                        pos_id: pos.id
                    });

                    var infowindow = new google.maps.InfoWindow({
                        content: pos.branch_contact_card
                    });

                    google.maps.event.addListener(markers[index], 'click', function () {
                        if (activeInfoWindow) {
                            activeInfoWindow.close()
                        }
                        infowindow.open(map, markers[index])
                        activeInfoWindow = infowindow
                    });
                });
            },
            removeAllMarkers() {
                for (var i = 0; i < markers.length; i++) {
                    markers[i].setMap(null);
                }
                markers = [];
            },
            focus() {
                if (this.selected_country) {
                    var lat_lon = this.countries_lat_lon[this.selected_country]
                    map.setCenter({lat: lat_lon[0], lng: lat_lon[1]});
                    map.setZoom(6);
                } else {
                    map.setCenter({lat: 25.358704, lng: 29.471082});
                    map.setZoom(2);
                }
            }
        }

    }
</script>
